import type { LoaderFunctionArgs } from 'react-router'
import { ensure, q } from '../data/queries'
import { canUse } from '../modules/tenants'

type Loader = (args: LoaderFunctionArgs) => Promise<unknown>

/**
 * Loader for a module page: prefetches its data only when the signed-in user's tenant can use the module
 * (and, for admin pages, the user is an admin). Otherwise the shell shows "Access not available".
 */
export function moduleLoader(key: string | null, load: Loader, { admin = false } = {}) {
  return async (args: LoaderFunctionArgs) => {
    const me = await ensure(q.me)
    if ((admin && !me.user.isAdmin) || (key && !canUse(me.modules, key))) return null
    await load(args)
    return null
  }
}
